module.exports = __webpack_public_path__ + "static/media/microscope-man-2018-05-30.7cebc4c4.svg";